import { Form, Input, Modal, Table, Radio, Select, notification } from 'antd'
import { useContext, useEffect, useState } from 'react'
import { PlusCircleTwoTone, CloudDownloadOutlined } from '@ant-design/icons'

import './styles.css'

import { Context } from '../../context'
import { Fetch, Post, Delete } from '../../fetch'
import { convertIdToKey, handleExportClick } from '../../utils'

const { Column } = Table
const { Option } = Select

const ManageMediaHouses = () => {
    const { token, apiUrl } = useContext(Context)

    const [mediaHouses, setMediaHouses] = useState([])
    const [modalVisible, setModalVisible] = useState(false)
    const [confirmLoading, setConfirmLoading] = useState(false)
    const [mediaHousesMaster, setMediaHousesMaster] = useState([])

    const [form] = Form.useForm()

    useEffect(() => {
        Fetch(`${apiUrl}/mediaHouses`, token, (result) => {
            const directors = convertIdToKey(result.directors)
            const producers = convertIdToKey(result.producers)
            setMediaHouses([...directors, ...producers])
            setMediaHousesMaster([...directors, ...producers])
        })
    }, [apiUrl, token, confirmLoading])

    const handleSubmit = async () => {
        try {
            setConfirmLoading(true)
            await form.validateFields()
            Post(
                `${apiUrl}/mediaHouses`,
                token,
                {
                    name: form.getFieldValue('name'),
                    mhType: form.getFieldValue('type')
                },
                (result) => {
                    if (result.success) {
                        notification.success({
                            message: 'Success',
                            description: 'Media House created'
                        })
                    }
                    form.resetFields()
                    setModalVisible(false)
                },
                () => {
                    notification.error({
                        message: 'Add Media House Error',
                        description: 'Check console for more details'
                    })
                }
            )
        } catch (err) {
            console.error(err)
            notification.error({
                message: 'Add Media House Error',
                description: 'Required fields are incorrect/missing'
            })
        } finally {
            setConfirmLoading(false)
        }
    }

    const handleDelete = async (id) => {
        try {
            await setConfirmLoading(true)
            Delete(
                `${apiUrl}/mediaHouses/${id}`,
                token,
                (result) => {
                    if (result.success) {
                        notification.success({
                            message: 'Success',
                            description: 'Media House deleted successfully'
                        })
                    }
                },
                () => {
                    notification.error({
                        message: 'Delete Media House Error',
                        description: 'Check console for more details'
                    })
                }
            )
        } finally {
            setConfirmLoading(false)
        }
    }

    const handleSearchChange = (mhId) => {
        if (!mhId)
            return

        setMediaHouses(mediaHouses.filter(mh => mh.key === mhId))
    }

    return (
        <div className="manage-episodes-wrapper">
            <Select
                placeholder="Search Media House"
                showSearch
                allowClear
                onChange={handleSearchChange}
                onClear={() => setMediaHouses(mediaHousesMaster)}
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                filterSort={(optionA, optionB) => optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())}
            >
                {mediaHousesMaster.map(mh => (
                    <Option value={mh.key}>{mh.name}</Option>
                ))}
            </Select>
            <Table dataSource={mediaHouses}>
                <Column title="Name" dataIndex="name" key="name" align="center" />
                <Column title="Type" dataIndex="mhType" key="mhType" align="center" />
                <Column
                    title="Actions"
                    key="action"
                    align="center"
                    render={(text, record) => (
                        <a onClick={() => handleDelete(record.key)}>Delete</a>
                    )}
                />
            </Table>
            <PlusCircleTwoTone twoToneColor="rgb(243, 101, 35)" style={{ fontSize: "48px" }} className="add-media-house-btn" onClick={() => setModalVisible(true)} />
            <CloudDownloadOutlined className="export-btn" onClick={() => handleExportClick(apiUrl, token, 'media_houses')} />
            <Modal
                title="Add Media House"
                visible={modalVisible}
                onOk={handleSubmit}
                okText="Submit"
                onCancel={() => setModalVisible(false)}
                confirmLoading={confirmLoading}
            >
                <Form form={form} layout="vertical" initialValues={{ type: "director" }}>
                    <Form.Item name="name" label="Name" rules={[{ required: true }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item name="type" label="Type" rules={[{ required: true }]}>
                        <Radio.Group>
                            <Radio value="Director">Director</Radio>
                            <Radio value="Producer">Producer</Radio>
                        </Radio.Group>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    )
}

export default ManageMediaHouses
